var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.921,
    height: 59.921,
    viewBox: "0 0 59.921 59.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(-75.368 -721.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(-2561 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    transform: "translate(2638.828 728.702)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.46
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 2.992,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.23,
    y: -1.23,
    width: 57.46,
    height: 57.46,
    rx: 4.222,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2660.329 735.744)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2674.788 735.744)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2645.87 750.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2660.329 750.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2674.788 750.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2645.87 764.662)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2660.329 764.662)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 11.999,
    height: 11.999,
    rx: 1.072,
    transform: "translate(2674.788 764.662)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlock);
export default __webpack_public_path__ + "static/media/icon-block.de2ba4a929ed11eb425ee8d8449d2904.svg";
export { ForwardRef as ReactComponent };